import React from 'react'

import { Backtotop,Floatinmenu, Underline} from "../../widgets";
import {Profile_display} from '../../components'

import { Chemistry_dept_fmenu,chemi_fac_profiles,chemi_sup_profiles } from '../../constants/chemistry_dept';
import { RadialMenu } from "../../components";


import { GrTest } from "react-icons/gr";

const Sh_Chemi_fac = () => {
  return (
    <div>
      <section className="shengdark">
            <div className="dept_float_menu">
              <Floatinmenu logo={GrTest} head="Menu" links={Chemistry_dept_fmenu} />
            </div>
            <RadialMenu menu_links={Chemistry_dept_fmenu} />
            <div className="sheng_fac_area">
                <div className='sheng_teach_fac'>
                    <Underline heading="Teaching Faculties"/>
                    <Profile_display list_info={chemi_fac_profiles}/>
                </div>
                <div className='sheng_teach_fac'>
                    <Underline heading="Supporting Faculties"/>
                    <Profile_display list_info={chemi_sup_profiles}/>
                </div>
            </div>
          </section>
          <Backtotop/>
    </div>
  )
}

export default Sh_Chemi_fac
